import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { GetMenusBO } from './menus-new.modal';

@Injectable({
    providedIn: 'root'
})

export class MenusDateService extends Subject<DataStateChangeEventArgs>{
    MenuList: any = [];
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
        super();
    }
    // Get Side Menus
    public executeParentMenu(Menusstate: GetMenusBO): void {
        this.getParentMenusList(Menusstate).subscribe(x => super.next(x));
    }
    getParentMenusList(Menusstate?: GetMenusBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/SideMenuItems/getParentMenu?", Menusstate)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['mList'],
                        count: response['totalCount']
                    }
            )).pipe(map((e: any) => {
                this.setDroplist(e.result)
                return e;
            })
            )
    }
    // Get Side Menus
    public executeSubMenu(Menusstate: GetMenusBO): void {
        this.getSubMenuList(Menusstate).subscribe(x => super.next(x));
    }
    getSubMenuList(Menusstate?: GetMenusBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/SideMenuItems/getSubMenu?", Menusstate)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['mList'],
                        count: response['totalCount']
                    }
            ))
    }
    //setDroplist
    setDroplist(data) {
        if (data.length > 0) {
            this.MenuList = JSON.parse(JSON.stringify(data));
            this.MenuList = data?.filter(Ms => Ms.isFunctionRequired == false && Ms.parentMenuItemId == null);
            this.getDroplist();
        }
    }
    //getDroplist
    getDroplist() {
        return this.MenuList;
    }
}
